import { React, useEffect, useState } from "react";
import NavBarTop from "../Reusable_Components/NavBarTop";
import { Button, Modal, Tab, Tabs } from "react-bootstrap";
import { base_url } from "../../utilities";
import axios from "axios";
import Loader from "../Reusable_Components/loader";
import AlertPopUp from "../Reusable_Components/Alert";
import { useNavigate } from "react-router-dom";
import PhoneInput from "react-phone-input-2";
import Footer from "../Login/Footer";
import TableComponent from "../Reusable_Components/TableComponent";
import LeftNavBar from "../Reusable_Components/LeftNavBar";

export default function CustomerProfile() {
    const navigate = useNavigate();

    const [activeTab, setActiveTab] = useState("1")
    const [isLoading, setIsLoading] = useState(false);
    const orgID = localStorage.getItem("org_id");

    //Organisation Details States
    const [businessGstNumber, setBusinessGstNumber] = useState("");
    const [businessName, setBusinessName] = useState("");
    const [businessHcnNumber, setBusinessHcnNumber] = useState("");
    const [orgDescription, setOrgDescription] = useState("");
    const [businessAddress, setBusinessAddress] = useState("");
    const [businessDoorNo, setBusinessDoorNo] = useState("");
    const [businessAddress2, setBusinessAddress2] = useState("");
    const [businessCity, setBusinessCity] = useState("");
    const [businessState, setBusinessState] = useState("");
    const [businessCountry, setBusinessCountry] = useState("");
    const [businessPincode, setBusinessPincode] = useState("");
    const [businessPhone, setBusinessPhone] = useState("");
    const [businessEmail, setBusinessEmail] = useState("");

    //Alert States
    const [alertShow, setAlertShow] = useState(false)
    const [alertType, setAlertType] = useState('')
    const [alertMessage, setAlertMessage] = useState('')
    const [alertValue, setAlertValue] = useState('')
    const [alertButtons, setAlertButtons] = useState([])

    //User Details States
    const [primaryContactName, setPrimaryContactName] = useState("");
    const [primaryContactPhoneNumber, setPrimaryContactPhoneNumber] = useState("");
    const [primaryContactEmail, setPrimaryContactEmail] = useState("");
    const [companyName, setCompanyName] = useState("");
    const [gstNumber, setGstNumber] = useState("");
    const [cinNumber, setCinNumber] = useState("");
    const [panNumber, setPanNumber] = useState("");
    const [streetAddress1, setStreetAddress1] = useState("");
    const [streetAddress2, setStreetAddress2] = useState("");
    const [city, setCity] = useState("");
    const [state, setState] = useState("");
    const [country, setCountry] = useState("");
    const [postalCode, setPostalCode] = useState("");
    const [firstName, setFirstName] = useState("")
    const [lastName, setLastName] = useState("")

    const name = localStorage.getItem("name")
    const phoneNumber = localStorage.getItem("phone_number")
    const email = localStorage.getItem("email")
    const userID = localStorage.getItem("user_id")

    const [gstPreviousModalClicked, setGstPreviousModalClicked] = useState(false);

    const [previousRecords, setPreviousRecords] = useState([
        {
            gst_number: "22ABCDE1234F1Z5",
            company_name: "ABC Pvt Ltd",
            cin: "U12345KA2025PTC123456",
            pan_number: "ABCDE1234F",
            address: "123, MG Road, Bengaluru, Karnataka, 560001, India",
            updated_at: "2025-10-05 15:30:00",
            updated_by: "admin2"
        },
        {
            gst_number: "33XYZDE1234F1Z6",
            company_name: "XYZ Ltd",
            cin: "U67890TN2025PLC654321",
            pan_number: "XYZDE1234F",
            address: "456, Anna Salai, Chennai, Tamil Nadu, 600002, India",
            updated_at: "2025-09-20 14:45:00",
            updated_by: "user2"
        }
    ]);




    const [listOfContacts, setListOfContacts] = useState([])
    const [contractsList, setContractsList] = useState([])

    const formatContactsForTable = (contracts) => {
        const contactsTableData = [];

        contracts?.forEach(contract => {
            // Add primary contact for this contract
            if (
                contract?.primary_contact_name ||
                contract?.primary_contact_email ||
                contract?.primary_contact_phone_number
            ) {
                contactsTableData.push({
                    contract_number: contract.contract_number,
                    contract_name: contract.contract_name,
                    contact_type: "Primary",
                    name: contract.primary_contact_name,
                    email: contract.primary_contact_email,
                    phone_number: contract.primary_contact_phone_number,
                });
            }

            // Add secondary contacts for this contract
            if (Array.isArray(contract.contacts)) {
                contract.contacts.forEach(contact => {
                    contactsTableData.push({
                        contract_number: contract.contract_number,
                        contract_name: contract.contract_name,
                        contact_type: "Secondary",
                        name: contact.name,
                        email: contact.email,
                        phone_number: contact.phone_number,
                    });
                });
            }
        });

        return contactsTableData;
    };

    const handleBack = () => {
        switch (activeTab) {
            case '3':
                setActiveTab('2');
                break;
            case '2':
                setActiveTab('1');
                break;
            default:
                break;
        }
    }

    useEffect(() => {

        if (orgID) {
            getOrganisationDetails(orgID);
        }
        if (userID) {
            getUserDetails(userID)
        }
    }, [orgID,userID]);

    useEffect(() => {
        const nameSplit = name?.split(" ")
        setFirstName(nameSplit?.[0])
        setLastName(nameSplit?.[1])
    }, [name]);

    const getOrganisationDetails = (orgID) => {
        setIsLoading(true);
        axios.get(`${base_url}subscription/organization`, {
            params: {
                filter_condition: JSON.stringify({
                    org_id: orgID
                })
            }
        })
            .then((res) => {
                setIsLoading(false);
                const response = res.data.data;
                const orgDetails = response?.[0];
                setBusinessGstNumber(orgDetails?.business_gst_number);
                setBusinessName(orgDetails?.business_name);
                setBusinessHcnNumber(orgDetails?.business_hcn_number);
                setOrgDescription(orgDetails?.org_description);
                setBusinessAddress(orgDetails?.business_address);
                setBusinessDoorNo(orgDetails?.business_door_number);
                setBusinessAddress2(orgDetails?.business_address2);
                setBusinessCity(orgDetails?.business_city);
                setBusinessState(orgDetails?.business_state);
                setBusinessCountry(orgDetails?.business_country);
                setBusinessPincode(orgDetails?.business_zipcode);
                setBusinessPhone(orgDetails?.business_phone);
                setBusinessEmail(orgDetails?.business_email);
            })
            .catch((err) => {
                setIsLoading(false);
                setAlertShow(true);
                setAlertType('error');
                setAlertMessage('Error');
                setAlertValue(err?.response?.data?.message);
                setAlertButtons([
                    {
                        name: 'Close',
                        action: () => {
                            setAlertShow(false);
                        }
                    }
                ]);
            })
    }

    const getUserDetails = (userID) => {
        setIsLoading(true);
        axios.get(`${base_url}customers/userCustomerDetails`, {
            params: {
                filter_condition: JSON.stringify({
                    user_id: userID
                })
            }
        })
            .then((res) => {
                const response = res?.data?.data;
                setPrimaryContactName(response?.primary_contact_name);
                setPrimaryContactPhoneNumber(response?.primary_contact_phone_number);
                setPrimaryContactEmail(response?.primary_contact_email);
                setCompanyName(response?.company_name);
                setGstNumber(response?.gst_number);
                setCinNumber(response?.cin);
                setPanNumber(response?.pan_number);
                setStreetAddress1(response?.registered_address?.street_address_1)
                setStreetAddress2(response?.registered_address?.street_address_2)
                setCity(response?.registered_address?.city)
                setState(response?.registered_address?.state)
                setCountry(response?.registered_address?.country)
                setPostalCode(response?.registered_address?.postal_code)

                setContractsList(response?.contracts)
                setListOfContacts(formatContactsForTable(response?.contracts));
                setIsLoading(false);
            })
            .catch((err) => {
                setIsLoading(false);
                setAlertShow(true);
                setAlertType('error');
                setAlertMessage('Error');
                setAlertValue(err?.response?.data?.message);
                setAlertButtons([
                    {
                        name: 'Close',
                        action: () => {
                            setAlertShow(false);
                        }
                    }
                ]);
            })
    }


    return (
        <>
            <>
                <NavBarTop />
                <LeftNavBar />

                <AlertPopUp alertShow={alertShow} alertType={alertType}
                    alertMsg={alertMessage} alertValue={alertValue} alertButtons={alertButtons} />
            </>
            {gstPreviousModalClicked && <Modal keyboard={false} backdrop="static" size='lg' show={gstPreviousModalClicked} onHide={() => setGstPreviousModalClicked(false)} centered className="popper-modal">
                <Modal.Body className="text-center">
                    <h5>Changed History</h5>
                    <div style={{ overflow: "auto" }}>
                        <TableComponent
                            headers={[{
                                name: "GST Number",
                                type: "text",
                                key: "gst_number"
                            }, {
                                name: "Company Name",
                                type: "text",
                                key: "company_name"
                            }, {
                                name: `CIN Number`,
                                type: "text",
                                key: "cin"
                            }, {
                                name: "PAN Number",
                                type: "text",
                                key: "pan_number"
                            }, {
                                name: "Address",
                                type: "text",
                                key: "address"
                            },
                            {
                                name: "updated At",
                                type: "time_stamp",
                                key: "updated_at"
                            },
                            {
                                name: "Updated By",
                                type: "text",
                                key: "updated_by"
                            }
                            ]}
                            data={previousRecords}
                        />
                    </div>
                </Modal.Body>
                <Modal.Footer className="d-flex justify-content-center" >
                    <Button variant="secondary" className="secondary" onClick={() => setGstPreviousModalClicked(false)} >
                        Close
                    </Button>
                </Modal.Footer>
            </Modal>}
            <div className="newAssetContainer" >
                <div
                    className="orgProfileContainer"
                >
                    <div>
                        <h2>Profile</h2>
                    </div>
                    <div className="custom-tabs" style={{ marginTop: "20px" }}>
                        <Tabs
                            activeKey={activeTab}
                            onSelect={(k) => setActiveTab(k)}
                            id="uncontrolled-tab-example"
                            className="mb-0"
                        >
                            <Tab eventKey="1" title="Basic Details"
                                className="assetTabs" >
                                <div className="infoBody" style={{ height: "57vh" }}>
                                    <div>
                                        <h6 style={{ fontWeight: "bold" }}>User Details</h6>
                                        <div className="infoBodyInputs">
                                            <div className="responsiveInputSection">
                                                <div >
                                                    <label className='add-facility-modal-label'
                                                    >First Name </label>
                                                    <input type='text'
                                                        disabled={true}
                                                        value={firstName}
                                                        className='form-control responsive-add-facility-input-fields' />
                                                </div>
                                                <div >
                                                    <label className='add-facility-modal-label'
                                                    >Last Name </label>
                                                    <input type='text'
                                                        disabled={true}
                                                        value={lastName}
                                                        className='form-control responsive-add-facility-input-fields' />
                                                </div>
                                                <div >
                                                    <label className='add-facility-modal-label'
                                                    >Phone Number </label>
                                                    <PhoneInput
                                                        country={'in'}
                                                        disabled={true}
                                                        value={phoneNumber}
                                                        inputClass="form-control responsive-add-facility-input-fields"
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div>
                                        <div className="infoBodyInputs">
                                            <div className="responsiveInputSection">
                                                <div >
                                                    <label className='add-facility-modal-label'
                                                    >Email  </label>
                                                    <input type='text'
                                                        disabled={true}
                                                        value={email}
                                                        className='form-control responsive-add-facility-input-fields' />
                                                </div>

                                            </div>

                                        </div>
                                    </div>
                                </div>
                            </Tab>
                            <Tab eventKey="2" title="My Company Details"
                                className="assetTabs" >
                                <div className="infoBody">
                                    <div>
                                        <div className="d-flex justify-content-between">
                                            <h6 style={{ fontWeight: "bold" }}>Company Details</h6>
                                            <span style={{ textDecoration: "underline", color: "#007bff", cursor: "pointer" }}
                                                onClick={() => {
                                                    setGstPreviousModalClicked(true);
                                                }
                                                }
                                            >
                                                Changed History
                                            </span>
                                        </div>
                                        <div className="infoBodyInputs">
                                            <div className="responsiveInputSection">
                                                <div style={{ display: "flex", flexDirection: "row" }}>
                                                    <div style={{ display: "flex", flexDirection: "column" }}>
                                                        <label className='add-facility-modal-label'>GST Number </label>
                                                        <input
                                                            type='text' value={gstNumber} className='form-control responsive-add-facility-input-fields' disabled={true} style={{ width: "90%", border: "0.5px solid #9D9D9C", }} />
                                                    </div>

                                                </div>
                                                <div >
                                                    <label className='add-facility-modal-label'
                                                    >CIN </label>
                                                    <input type='text'
                                                        disabled={true}
                                                        value={cinNumber}
                                                        className='form-control responsive-add-facility-input-fields' />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <hr></hr>
                                    <div>
                                        <h6 style={{ fontWeight: "bold" }}>Registered Address</h6>
                                        <div className="infoBodyInputs">
                                            <div className="responsiveInputSection">

                                                <div >
                                                    <label className='add-facility-modal-label'
                                                    >Company Name </label>
                                                    <input type='text'
                                                        disabled={true}
                                                        value={companyName}
                                                        className='form-control responsive-add-facility-input-fields' />
                                                </div>
                                                <div >
                                                    <label className='add-facility-modal-label'
                                                    >PAN </label>
                                                    <input type='text'
                                                        disabled={true}
                                                        value={panNumber}
                                                        className='form-control responsive-add-facility-input-fields' />
                                                </div>
                                                <div >
                                                    <label className='add-facility-modal-label'
                                                    >Street Address  </label>
                                                    <input type='text'
                                                        disabled={true}
                                                        value={streetAddress1}
                                                        className='form-control responsive-add-facility-input-fields' />
                                                </div>



                                            </div>
                                            <div className="responsiveInputSection">
                                                <div >
                                                    <label className='add-facility-modal-label'
                                                    >Street Address Lane 2 </label>
                                                    <input type='text'
                                                        disabled={true}
                                                        value={streetAddress2}
                                                        className='form-control responsive-add-facility-input-fields' />
                                                </div>
                                                <div>
                                                    <label className='add-facility-modal-label'>City </label>
                                                    <input type='text'
                                                        disabled={true}
                                                        value={city}
                                                        className='form-control responsive-add-facility-input-fields' />

                                                </div>
                                                <div >
                                                    <label className='add-facility-modal-label'
                                                    >State/Province </label>
                                                    <input type='text'
                                                        disabled={true}
                                                        value={state}
                                                        className='form-control responsive-add-facility-input-fields' />
                                                </div>


                                            </div>
                                            <div className="responsiveInputSection">


                                                <div >
                                                    <label className='add-facility-modal-label'
                                                    >Country </label>
                                                    <input type='text'
                                                        disabled={true}
                                                        value={country}
                                                        className='form-control responsive-add-facility-input-fields' />

                                                </div>
                                                <div>
                                                    <label className='add-facility-modal-label'>PIN Code </label>
                                                    <input type='text'
                                                        disabled={true}
                                                        value={postalCode}
                                                        className='form-control responsive-add-facility-input-fields' />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <hr></hr>

                                    <div>
                                        <h6 style={{ fontWeight: "bold" }}>Contact Information</h6>
                                        <div className="infoBodyInputs">
                                            <div className="responsiveInputSection">
                                                <TableComponent
                                                    headers={[{
                                                        name: "Contract Number",
                                                        type: "text",
                                                        key: "contract_number",
                                                        sort: true
                                                    }, {
                                                        name: "Contract Name",
                                                        type: "text",
                                                        key: "contract_name",
                                                        sort: true
                                                    }, {
                                                        name: "Type",
                                                        type: "text",
                                                        key: "contact_type",
                                                        sort: true
                                                    }, {
                                                        name: "Contact Name",
                                                        type: "text",
                                                        key: "name",
                                                        sort: true
                                                    }, {
                                                        name: "Email",
                                                        type: "text",
                                                        key: "email",
                                                        sort: true
                                                    }, {
                                                        name: "Phone Number",
                                                        type: "text",
                                                        key: "phone_number",
                                                        sort: true
                                                    }
                                                    ]}
                                                    data={listOfContacts}

                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>


                            </Tab>
                            <Tab eventKey="3" title="Organization Details"
                                className="assetTabs" >
                                <div className="infoBody" >
                                    <div>
                                        <h6 style={{ fontWeight: "bold" }}>Organization Details</h6>
                                        <div className="infoBodyInputs">
                                            <div className="responsiveInputSection">
                                                <div style={{ display: "flex", flexDirection: "row" }}>
                                                    <div style={{ display: "flex", flexDirection: "column" }}>
                                                        <label className='add-facility-modal-label'>GST Number </label>
                                                        <input
                                                            type='text' className='form-control responsive-add-facility-input-fields' value={businessGstNumber} disabled={true} style={{ width: "90%", border: "0.5px solid #9D9D9C", }} />
                                                    </div>

                                                </div>
                                                <div >
                                                    <label className='add-facility-modal-label'
                                                    >Company Name </label>
                                                    <input type='text'
                                                        disabled={true}
                                                        value={businessName}
                                                        className='form-control responsive-add-facility-input-fields' />
                                                </div>

                                                <div>
                                                    <label className='add-facility-modal-label'>HCN Number </label>
                                                    <input type='text'
                                                        disabled={true}
                                                        value={businessHcnNumber}
                                                        className='form-control responsive-add-facility-input-fields' />

                                                </div>


                                            </div>


                                        </div>
                                    </div>
                                    <hr></hr>

                                    <div>
                                        <h6 style={{ fontWeight: "bold" }}>Registered Address</h6>
                                        <div className="infoBodyInputs">
                                            <div className="responsiveInputSection">
                                                <div >
                                                    <label className='add-facility-modal-label'
                                                    >Street Address  </label>
                                                    <input type='text'
                                                        disabled={true}
                                                        value={businessAddress}
                                                        className='form-control responsive-add-facility-input-fields' />
                                                </div>
                                                <div >
                                                    <label className='add-facility-modal-label'
                                                    >Street Address Lane 2 </label>
                                                    <input type='text'
                                                        disabled={true}
                                                        value={businessAddress2}
                                                        className='form-control responsive-add-facility-input-fields' />
                                                </div>
                                                <div>
                                                    <label className='add-facility-modal-label'>City </label>
                                                    <input type='text'
                                                        disabled={true}
                                                        value={businessCity}
                                                        className='form-control responsive-add-facility-input-fields' />

                                                </div>


                                            </div>
                                            <div className="responsiveInputSection">
                                                <div >
                                                    <label className='add-facility-modal-label'
                                                    >State/Province </label>
                                                    <input type='text'
                                                        disabled={true}
                                                        value={businessState}
                                                        className='form-control responsive-add-facility-input-fields' />
                                                </div>
                                                <div >
                                                    <label className='add-facility-modal-label'
                                                    >Country </label>
                                                    <input type='text'
                                                        disabled={true}
                                                        value={businessCountry}
                                                        className='form-control responsive-add-facility-input-fields' />

                                                </div>
                                                <div>
                                                    <label className='add-facility-modal-label'>PIN Code </label>
                                                    <input type='text'
                                                        disabled={true}
                                                        value={businessPincode}
                                                        className='form-control responsive-add-facility-input-fields' />
                                                </div>


                                            </div>

                                        </div>
                                    </div>

                                    <hr></hr>

                                    <div>
                                        <h6 style={{ fontWeight: "bold" }}>Contact Information</h6>
                                        <div className="infoBodyInputs">
                                            <div className="responsiveInputSection">
                                                <div >
                                                    <label className='add-facility-modal-label'
                                                    >Phone Number  </label>
                                                    <input type='text'
                                                        disabled={true}
                                                        value={businessPhone}
                                                        className='form-control responsive-add-facility-input-fields' />
                                                </div>
                                                <div >
                                                    <label className='add-facility-modal-label'
                                                    >Email  </label>
                                                    <input type='text'
                                                        disabled={true}
                                                        value={businessEmail}
                                                        className='form-control responsive-add-facility-input-fields' />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </Tab>
                        </Tabs>
                    </div>
                    <div style={{ marginTop: "20px", }}>
                        {
                            activeTab === '1' && (
                                <div style={{ display: "flex", justifyContent: "end", }}>
                                    <button className="infoNextBtn" style={{ marginLeft: "30px", color: "white" }} onClick={() => {
                                        // go back to the previous page
                                        navigate(-1)
                                    }}>Close</button>
                                    <button className="infoNextBtn" style={{ marginLeft: "30px", color: "white" }} onClick={() => {
                                        setActiveTab('2')
                                    }}>Next</button>
                                </div>
                            )
                        }
                        {
                            activeTab === '2' && (
                                <div style={{ display: "flex", justifyContent: "end", }}>
                                    <button className="infoNextBtn" style={{ marginLeft: "30px", color: "white" }} onClick={() => {
                                        // go back to the previous page
                                        navigate(-1)
                                    }}>Close</button>
                                    <button className="infoNextBtn" style={{ marginLeft: "30px", color: "white" }} onClick={handleBack}>Back</button>

                                    <button className="infoNextBtn" style={{ marginLeft: "30px", color: "white" }} onClick={() => {
                                        setActiveTab('3')
                                    }}>Next</button>

                                </div>
                            )
                        }
                        {
                            activeTab === '3' && (
                                <div style={{ display: "flex", justifyContent: "end", }}>
                                    <button className="infoNextBtn" style={{ marginLeft: "30px", color: "white" }} onClick={() => {
                                        // go back to the previous page
                                        navigate(-1)
                                    }}>Close</button>
                                    <button className="infoNextBtn" style={{ marginLeft: "30px", color: "white" }} onClick={handleBack}>Back</button>
                                </div>
                            )
                        }

                    </div>
                </div>
            </div>
            {isLoading && <Loader />}
            <Footer />
        </>
    );
}